import React from 'react';
import {Typography, Box, Grid, Button} from '@material-ui/core/';
import {
    Link
} from 'react-router-dom';

export default function Restaurant(props){
    return(
        <div>
        <Box m={5}>
        <Typography variant='h5'>Great, we’re here to help. Are you a current GrubHub partner or do you operate independently/work with a different delivery service?
</Typography>
        </Box>
        <Grid container spacing={3}>
        <Grid item xs={6}>
          <Button variant="contained" color="primary" component={Link} to='/restaurant/currentpartner'>
         Current GrubHub Partner
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button variant="contained" color="primary" component={Link} to='/restaurant/independent'>
          Independent/Different Service 
          </Button>
        </Grid>
        </Grid>
        </div>
    );
}
